import React from 'react'

const AllServicesIcon = ({ className, size = 24 }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="all-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(255, 215, 0, 1)" />
          <stop offset="50%" stopColor="rgba(255, 180, 50, 1)" />
          <stop offset="100%" stopColor="rgba(255, 150, 50, 1)" />
        </linearGradient>
        <filter id="all-glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Grid of services */}
      <rect x="3" y="3" width="7" height="7" rx="1.5" stroke="url(#all-grad)" strokeWidth="2" filter="url(#all-glow)"/>
      <rect x="14" y="3" width="7" height="7" rx="1.5" stroke="url(#all-grad)" strokeWidth="2" filter="url(#all-glow)"/>
      <rect x="3" y="14" width="7" height="7" rx="1.5" stroke="url(#all-grad)" strokeWidth="2" filter="url(#all-glow)"/>
      <rect x="14" y="14" width="7" height="7" rx="1.5" stroke="url(#all-grad)" strokeWidth="2" filter="url(#all-glow)"/>
      
      {/* Inner sparkles */}
      <circle cx="6.5" cy="6.5" r="1.5" fill="url(#all-grad)" opacity="0.7"/>
      <circle cx="17.5" cy="6.5" r="1.5" fill="url(#all-grad)" opacity="0.7"/>
      <circle cx="6.5" cy="17.5" r="1.5" fill="url(#all-grad)" opacity="0.7"/>
      <circle cx="17.5" cy="17.5" r="1.5" fill="url(#all-grad)" opacity="0.7"/>
      
      {/* Connection lines */}
      <line x1="10" y1="6.5" x2="14" y2="6.5" stroke="url(#all-grad)" strokeWidth="1.5" opacity="0.4"/>
      <line x1="10" y1="17.5" x2="14" y2="17.5" stroke="url(#all-grad)" strokeWidth="1.5" opacity="0.4"/>
      <line x1="6.5" y1="10" x2="6.5" y2="14" stroke="url(#all-grad)" strokeWidth="1.5" opacity="0.4"/>
      <line x1="17.5" y1="10" x2="17.5" y2="14" stroke="url(#all-grad)" strokeWidth="1.5" opacity="0.4"/>
    </svg>
  )
}

export default AllServicesIcon
